import { Box, Modal } from "@mui/material";
import React, { useState, useRef, useEffect, useCallback } from "react";
import _ from "lodash";
import { DatePicker, Space } from 'antd';
import { strToDate } from "../../constant";

const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

const disabledDate = (current) => {
    return current && current < new Date().setHours(0, 0, 0, 0);
};
const RfqExtendValidaityModal = (props) => {
    return (
        <>
            <Modal
                open={props.opnextendvalidtymodal}
                onClose={() => props.setOpnExtendValidtyModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style1} className="modal_react_controlpanel_employees">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">
                            Extend Validty
                        </h1>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            fdprocessedid="kum8iho"
                            onClick={() => props.setOpnExtendValidtyModal(false)}
                        ></button>
                    </div>
                    <div class="modal-body">
                        <div class="lets_modal_vendor">
                            <div class="lets_select_sme">
                                <label class="mb-1 text-dark">
                                    REQ No.
                                    <span class="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="reqNumber"
                                    class="form-control form_h_modal"
                                    placeholder="GHSTH123"
                                    required=""
                                    fdprocessedid="lxbmbt"
                                    value={props.rfqNumber}
                                    disabled

                                />
                                <div class="error-message" id="reqNumberError"></div>
                            </div>

                        </div>

                        <div class="lets_modal_vendor">
                            <div class="col-sm-7">
                                <label class="mb-1 text-dark">
                                    Current Validity
                                    <span class="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="currentContactName"
                                    class="form-control form_h_modal"
                                    placeholder="8/01/2024 - 10/01/2024"
                                    required=""
                                    fdprocessedid="lxbmbt"
                                    value={`${strToDate(props?.currentRfqValidity.from)} - ${strToDate(props?.currentRfqValidity.to)}`}
                                    disabled
                                />


                                <div
                                    class="error-message"
                                    id="currentContactNameError"
                                ></div>
                            </div>
                            <div class="col-sm-4">
                                <label class="mb-1 text-dark">
                                    Current Period
                                    <span class="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="currentValidity"
                                    className="form-control form_h_modal"
                                    placeholder=""
                                    value={props.currentValidityPeriod}
                                    disabled
                                />
                                <div class="error-message" id="currentValidityError"></div>
                            </div>

                        </div>

                        <div class="lets_modal_vendor">
                            <div class="col-sm-7">
                                <label class="mb-1 text-dark">
                                    New Validity
                                    <span class="required">*</span>
                                </label>

                                <Space direction="vertical" size={12}>
                                    <DatePicker.RangePicker getPopupContainer={trigger => trigger.parentNode} placement="bottomLeft" onChange={props.handleNewDatePickerChange}   format="DD-MM-YYYY" />
                                </Space>
                                <div
                                    class="error-message"
                                    id="currentContactNameError"
                                ></div>
                            </div>
                            <div class="col-sm-4">
                                <label class="mb-1 text-dark">
                                    New Validity
                                    <span class="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="currentValidity"
                                    class="form-control form_h_modal"
                                    placeholder=""
                                    required=""
                                    fdprocessedid="v4x9ts"
                                    value={props.newValidityPeriod}
                                    disabled
                                />
                                <div class="error-message" id="currentValidityError"></div>
                            </div>

                        </div>
                    </div>
                    <div class="closebtn_submit_block_btn">
                        <button
                            type="button"
                            class="btn clear_btn_status_block_lists"
                            fdprocessedid="wshspp"
                            onClick={() => props.closeExtendValidty()}
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            class="btn btn-success"
                            onClick={props.handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </Box>
            </Modal>
        </>
    );
};

export default RfqExtendValidaityModal;
